import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=486f2c76"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486f2c76')) {
      api.createRecord('486f2c76', component.options)
    } else {
      api.reload('486f2c76', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=486f2c76", function () {
      api.rerender('486f2c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/Message.vue"
export default component.exports